import axios from 'axios'

const state = {
	list: [],
};

const mutations = {
	SET_LIST: (state, list) => {
		state.list = list;
	},
}

const options = {
	headers: {
		'Accept': 'application/vnd.api+json',
		'Content-Type': 'application/vnd.api+json',
	}
};

const actions = {

	getActivites() {
		return axios.get(process.env.VUE_APP_API_BASE_URL+'/activities')
			.then((response) => {
				return response
			})
	},

	addActivites(context, payload) {
		return axios.post(process.env.VUE_APP_API_BASE_URL+'/activities', payload, options)
			.then((response) => {
				return response
			})
	},

	updateActivites(context, payload) {
		return axios.put(process.env.VUE_APP_API_BASE_URL+'/activities/' + payload.id, payload, options)
			.then((response) => {
				return response
			})
	},

}

const getters = {
	list: state => state.list,
};

const activities = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};

export default activities;
